export const firebaseConfig = {

  apiKey: "AIzaSyAqzioeTfaSh5tY0zZJiAVoMALQTGeG_ew",

  authDomain: "ren-ctf-webapp.firebaseapp.com",

  projectId: "ren-ctf-webapp",

  storageBucket: "ren-ctf-webapp.firebasestorage.app",

  messagingSenderId: "191118208644",

  appId: "1:191118208644:web:9030f907e4c85dde0f1cd1",

  measurementId: "G-QKTHL27FCG"

};

